import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-gradient-to-br from-orange-50 to-amber-50 rounded-xl sm:rounded-2xl p-4 sm:p-6 border-2 border-orange-100" }
const _hoisted_2 = { class: "flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6" }
const _hoisted_3 = { class: "text-lg sm:text-xl font-bold text-slate-800" }
const _hoisted_4 = {
  key: 0,
  class: "text-red-500 font-bold"
}
const _hoisted_5 = { class: "border-2 border-dashed border-orange-300 rounded-xl p-6 sm:p-8 text-center bg-white/60 hover:bg-white/80 transition-colors cursor-pointer mb-4" }
const _hoisted_6 = {
  key: 0,
  class: "text-center py-8 bg-white/60 rounded-xl"
}
const _hoisted_7 = {
  key: 1,
  class: "grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4"
}
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "absolute bottom-1.5 left-1.5 sm:bottom-2 sm:left-2 bg-black/70 text-white px-2 py-0.5 sm:py-1 rounded text-xs" }

interface Props {
  imagenes: File[];
  imagenesPreview: string[];
  /** Si es true, el producto debe tener al menos una imagen (p. ej. alta nueva). */
  requiereImagen?: boolean;
}

interface Emits {
  (e: "update:imagenes", value: File[]): void;
  (e: "update:imagenesPreview", value: string[]): void;
  (e: "eliminar", index: number): void;
}

const MAX_IMAGE_SIZE = 5 * 1024 * 1024;


export default /*@__PURE__*/_defineComponent({
  __name: 'ImagenesProducto',
  props: {
    imagenes: {},
    imagenesPreview: {},
    requiereImagen: { type: Boolean, default: false }
  },
  emits: ["update:imagenes", "update:imagenesPreview", "eliminar"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const ALLOWED_IMAGE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
];
const handleFileChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  if (target.files) {
    const newFiles = Array.from(target.files).filter((file) => {
      if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
        alert(`"${file.name}" no es un tipo permitido. Use PNG, JPG, GIF o WEBP.`);
        return false;
      }
      if (file.size <= 0) {
        alert(`"${file.name}" está vacío o no se pudo leer correctamente.`);
        return false;
      }
      if (file.size > MAX_IMAGE_SIZE) {
        alert(`"${file.name}" supera el máximo permitido de 5MB.`);
        return false;
      }
      return true;
    });
    if (newFiles.length === 0) {
      target.value = '';
      return;
    }
    const nuevasImagenes = [...props.imagenes, ...newFiles];
    emit("update:imagenes", nuevasImagenes);

    // Previews síncronos (evita condición de carrera con varios FileReader en paralelo)
    const nuevosPreviews = newFiles.map((file) => URL.createObjectURL(file));
    emit("update:imagenesPreview", [...props.imagenesPreview, ...nuevosPreviews]);

    // Limpiar el input para permitir seleccionar el mismo archivo de nuevo
    target.value = '';
  }
};

const eliminarImagen = (index: number) => {
  emit("eliminar", index);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "bg-orange-600 p-2 sm:p-2.5 rounded-lg" }, [
        _createElementVNode("svg", {
          class: "w-5 h-5 sm:w-6 sm:h-6 text-white",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [
          _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
          })
        ])
      ], -1)),
      _createElementVNode("h3", _hoisted_3, [
        _cache[0] || (_cache[0] = _createTextVNode(" Imágenes del Producto ", -1)),
        (props.requiereImagen)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "*"))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("input", {
        type: "file",
        onChange: handleFileChange,
        accept: "image/jpeg,image/png,image/gif,image/webp",
        multiple: "",
        class: "hidden",
        id: "file-upload"
      }, null, 32),
      _cache[2] || (_cache[2] = _createStaticVNode("<label for=\"file-upload\" class=\"cursor-pointer\"><svg class=\"w-12 h-12 sm:w-16 sm:h-16 mx-auto text-orange-300 mb-3\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12\"></path></svg><p class=\"text-slate-600 font-medium mb-1 text-sm sm:text-base\">Haz clic para subir imágenes</p><p class=\"text-slate-500 text-xs sm:text-sm\">o arrastra y suelta</p><p class=\"text-slate-400 text-xs mt-2\">PNG, JPG, GIF, WEBP hasta 5MB</p></label>", 1))
    ]),
    (__props.imagenesPreview.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("svg", {
            class: "w-10 h-10 sm:w-12 sm:h-12 mx-auto text-orange-300 mb-2",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
            })
          ], -1),
          _createElementVNode("p", { class: "text-slate-600 text-sm sm:text-base" }, "No hay imágenes cargadas", -1)
        ]))]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.imagenesPreview, (preview, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "relative group aspect-square"
            }, [
              _createElementVNode("img", {
                src: preview,
                alt: `Preview ${index + 1}`,
                class: "w-full h-full object-cover rounded-lg sm:rounded-xl border-2 border-orange-200"
              }, null, 8, _hoisted_8),
              _createElementVNode("button", {
                onClick: ($event: any) => (eliminarImagen(index)),
                type: "button",
                class: "absolute top-1.5 right-1.5 sm:top-2 sm:right-2 bg-red-600 text-white p-1.5 sm:p-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity hover:bg-red-700"
              }, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("svg", {
                  class: "w-3.5 h-3.5 sm:w-4 sm:h-4",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                  })
                ], -1)
              ]))], 8, _hoisted_9),
              _createElementVNode("div", _hoisted_10, _toDisplayString(index + 1), 1)
            ]))
          }), 128))
        ]))
  ]))
}
}

})